import { RequestFreightDetail } from 'TypeGen/Order/Load/request-freight-detail';
import { IDNameViewModel } from 'TypeGen/id-name-view-model';
import { formatNumber } from '@progress/kendo-intl';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Link, Typography } from '@mui/material';
import { FreightDetail } from 'TypeGen/Order/Load/freight-detail';

type Props = {
  dimsUnitOfMeasure: IDNameViewModel[];
  data: FreightDetail;
  request: RequestFreightDetail;
  updateRequest: (request: Partial<RequestFreightDetail>) => void;
}

const DimsInput = ({ data, request, updateRequest, dimsUnitOfMeasure }: Props) => {
  const dimsUoM = (dimsUoM: number) => dimsUnitOfMeasure.find(x => x.ID === dimsUoM)!.Name;
  return <>
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginTop: '1rem' }}>
      <NumericTextBox
        fillMode={'outline'}
        value={request.Length === 0 ? null : request.Length}
        placeholder="Length"
        min={0}
        spinners={false}
        onChange={(e) => updateRequest({ Length: e.value || 0 })}
      />
      <NumericTextBox
        fillMode={'outline'}
        value={request.Width === 0 ? null : request.Width}
        placeholder="Width"
        min={0}
        spinners={false}
        onChange={(e) => updateRequest({ Width: e.value || 0 })}
      />
      <NumericTextBox
        fillMode={'outline'}
        value={request.Height === 0 ? null : request.Height}
        placeholder="Height"
        min={0}
        spinners={false}
        onChange={(e) => updateRequest({ Height: e.value || 0 })}
      />
      <DropDownList
        data={dimsUnitOfMeasure}
        textField="Name"
        dataItemKey="ID"
        value={dimsUnitOfMeasure.find(x => x.ID === request.DimsUnitOfMeasure)}
        onChange={(e) => updateRequest({ DimsUnitOfMeasure: e.value?.ID || 0 })}
      />
    </div>
    <Typography
      variant="body2"
      color="textSecondary"
    >
      Requested <Link onClick={() => updateRequest({ Length: data.Length, Width: data.Width, Height: data.Height, DimsUnitOfMeasure: data.DimsUnitOfMeasure })}>{formatNumber(data.Length, 'n0')}x{formatNumber(data.Width, 'n0')}x{formatNumber(data.Height, 'n0')} {dimsUoM(data.DimsUnitOfMeasure)}</Link>
    </Typography>
  </>;
};

export default DimsInput;